import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomHttpParams } from '../api-handler/api-handler.service';
import { Guid } from 'guid-typescript';
import { v4 as uuidv4 } from 'uuid';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';

/** This method intercepts the http request and set the headers required by Account management*/
@Injectable()
export class SubscriptionHeaderInterceptorService implements HttpInterceptor {
  /**
  * has a dependency on domain matcher to generate a dynamic X-channel
  * DomainMatcher
  **/
  constructor(public ngRedux: NgRedux<AppState>) { }

  /**
  * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
  * @args domainMatcher
  * @returns The response that is being intercepted so it can continue to the Network call
  **/
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};
    if (req.params instanceof CustomHttpParams && req.params.spec) {
      switch (req.params.spec) {
        case 'vin':
        case 'vehicle_list':
        case 'preview':
        case 'cvs_details':
        case 'remote-command':
        case 'remote-command-24mm':
        case 'att-wifi-status':
        case 'delete-account':
        case 'unlink-vehicle':
        case 'get-provisioning':
        case 'retriger-provisioning':
        case 'hu-company':
        case 'subscription-history':
        case 'update-emergency-contact':
        case 'emergency-contact':
        case 'get-zuora-information':
        case 'jsd-group-info':
        case 'home-dealer':
        case 'preferred-dealer':
        case 'outage-banner':
        case 'vehicle-history':
        case 'product-packages':
        case 'provision-history':
        case 'linked-accounts-21mm':
        case 'unlink-vehicle':
        case 'userprofile-21mm':
        case 'digital_Key':
        case 'register-vehicle-21mm':
        case 'give-goodwill':
        case 'submit-goodwill':
        case 'sendCode':
        case 'auth_remote_legacy':
        case 'subaru':
        case 'data-consents':
        case 'sms-consent':
        case 're-sync-settable-flags':
        case 'update-remote-user':
        case 'dcm-activation':
        case 'get-vehicle-association':
        case 'dcm-deactivation':
        case 'rental-summary':
        case 'plug_and_charge':
        case 'phone-compatibility':
        case 'trial-lengths':
          headers = this.getPortalHeaders(req.params.spec);
          break;
      }
    }
    return next.handle(req.clone({
      setHeaders: headers
    }));
  }
  /**
  * getPortalHeaders Return the common headers on the request
  **/
  public getPortalHeaders(type): object {
    const isProvisioningOperation = ['get-provisioning', 'retriger-provisioning', 'provision-history', 'dcm-activation', 'dcm-deactivation'].includes(type);
    const headers = {
      'x-correlationid': isProvisioningOperation ? uuidv4() : Guid.create().toString(),
      'Authorization': `Bearer ${this.ngRedux.getState().auth.token}`,
      'X-CHANNEL': 'OP_ADMIN',
    };
    switch (type) {
      case 'vin':
        Object.assign(headers, { 'X-BRAND': 'T' });
        break;
      case 'preview':
      case 'vehicle_list':
      case 'update-remote-user':
        Object.assign(headers, { 'DATETIME': `${new Date().getTime()}` });
        break;
      case 'cvs_details':
      case 're-sync-settable-flags':
        Object.assign(headers, { 'X-CHANNEL': 'CTP' });
        break;
      case 'remote-command':
        delete headers['X-CHANNEL'];
        delete headers['x-correlationid'];
        break;
      case 'remote-command-24mm':
        Object.assign(headers, { 'X-CHANNEL': 'OP_ADMIN' });
        break;
      case 'jsd-group-info':
        Object.assign(headers, { 'Access-Control-Allow-Origin': '*' });
        break;
      case 'linked-accounts-21mm':
      case 'unlink-vehicle':
      case 'plug_and_charge':
        delete headers['X-CHANNEL'];
        break;
      case 'sendCode':
        Object.assign(headers, { 'X-CHANNEL': 'OP_ADMIN' });
        break;
      case 'auth_remote_legacy':
        Object.assign(headers, { 'X-CHANNEL': 'OP_ADMIN' });
        delete headers['x-correlationid'];
        break;
      case 'subaru':
        Object.assign(headers, { 'X-CHANNEL': 'OP_ADMIN' });
        Object.assign(headers, { 'X-BRAND': 'S' });
        delete headers['DATETIME'];
        break;
      case 'preferred-dealer':
        delete headers['x-correlationid'];
        delete headers['X-CHANNEL'];
        break;
      case 'product-packages':
        Object.assign(headers, { 'X-CHANNEL': 'ORCH_PROD' });
        break;
      case 'userprofile-21mm':
        delete headers['X-CHANNEL'];
        break;
      case 'give-goodwill':
      case 'submit-goodwill':
        Object.assign(headers, { 'DATETIME': `${new Date().getTime()}` });
        Object.assign(headers, { 'X-CHANNEL': 'CT_PORTAL' });
        break;
      case 'data-consents':
      case 'sms-consent':
        delete headers['X-CHANNEL'];
        break;
      case 'get-vehicle-association':
        Object.assign(headers, { 'X-CHANNEL': 'OP_ADMIN' });
        break;
      case 'rental-summary':
        Object.assign(headers, { 'X-CHANNEL': 'CT_ACM' });
        break;
    }
    return headers;
  }
}
